import {MaltClassicCreationStepName, maltClassicCreationSteps} from '@/profile-creation-wizard/config/steps/MaltClassicCreationSteps';
import {ProfileCreationFunnelMode, RoutesConfig} from '@/profile-creation-wizard/config/steps/ProfileCreationSteps';
import ProfileCreationRouterHelper from '@/profile-creation-wizard/router/ProfileCreationRouterHelper';

const maltClassicRoutesConfig: RoutesConfig = {
    routes: maltClassicCreationSteps.map((step) => ProfileCreationRouterHelper.buildRouteFromStep(step, ProfileCreationFunnelMode.FREELANCER)),
    creationFirstStep: MaltClassicCreationStepName.SIGNUP_HEADLINE,
    completionFirstStep: MaltClassicCreationStepName.COMPLETION_DESCRIPTION,
};

export default maltClassicRoutesConfig;
